import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { cx } from "./cx";
import { Icon, type IconProps } from "./icons";

export type ButtonVariant = "primary" | "secondary" | "subtle" | "ghost" | "danger";
export type ButtonSize = "sm" | "md" | "lg" | "xl";

/** A Lucide icon component, or something already rendered. */
export type IconRef = LucideIcon | ReactNode;

function isLucide(value: unknown): value is LucideIcon {
  return (
    typeof value === "function" ||
    (typeof value === "object" && value !== null && "render" in value)
  );
}

/** Class names for a link styled as a button (`<Link className={buttonClass(...)}>`). */
export function buttonClass(variant: ButtonVariant = "secondary", size: ButtonSize = "md", extra?: string) {
  return cx("rd-btn", `rd-btn-${variant}`, size !== "md" && `rd-btn-${size}`, extra);
}

/** Renders an `IconRef`: a Lucide component at `size`, anything else as given. */
export function renderIcon(ref: IconRef | undefined, size: number, extra?: Partial<IconProps>): ReactNode {
  if (ref == null || ref === false) return null;
  return isLucide(ref) ? <Icon icon={ref} size={size} {...extra} /> : ref;
}

